import React, { useMemo, memo } from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Tooltip } from "@mui/material";
import { FormQuestionDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { StyledNoteButton } from "./NoteButton.styled";

import { Typography } from "@components/base";
import { useGetFormDraftNote } from "@api";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";
import { useUserStore } from "@store/user";

interface NoteButton {
  question: FormQuestionDto;
  isOpen: boolean;
  onClick: () => void;
}

const NoteButton: React.FC<NoteButton> = ({ question, isOpen, onClick }) => {
  const {
    formSettings: { formBasics },
  } = useMultistepFormStore();
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { formDraftNote, formDraftNoteEnabled } = useGetFormDraftNote(
    user,
    formBasics.id,
  );

  const note = useMemo(
    () => formDraftNote?.find((n) => n.questionCode === question.code),
    [formDraftNote, question.code],
  );

  return (
    formDraftNoteEnabled && (
      <Tooltip
        title={
          isOpen ? (
            <Typography variant="body2">{t("forms.notes.hide")}</Typography>
          ) : (
            <div>
              <Typography variant="body2" fontWeight={500}>
                {t("forms.notes.titleNotesAttachmentsTitle")}
              </Typography>
              <Typography variant="body2">
                {t("forms.notes.title")} {note ? 1 : 0}
              </Typography>
              <Typography variant="body2">
                {t("forms.notes.attachments")} {note ? note.attachments.length : 0}
              </Typography>
            </div>
          )
        }
      >
        <StyledNoteButton hasContent={!!note} isExpanded={isOpen} onClick={onClick}>
          <ChatBubbleOutlineIcon />
        </StyledNoteButton>
      </Tooltip>
    )
  );
};

export default memo(NoteButton);
